import { Component, Input } from "@angular/core";

import { Discussion, User } from "../../../../../shared/models";
import { UserService } from "../../../../../shared/services";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

@Component({
  selector: "discussion-meta-panel",
  templateUrl: "./discussion-meta-panel.component.html",
  styleUrls: [
    "./discussion-meta-panel.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionMetaPanelComponent {
  public defaultUserImg: string =
    "../../../../../../assets/images/uMuzi/african-mask.png";
  public currentUser: User;
  public isUser: boolean;
  @Input() discussion: Discussion;

  constructor(private userService: UserService) {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  ngOnInit() {
    // Load the current user's data
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
      this.isUser =
        this.currentUser.username === this.discussion.author.username;
    });
  }

  public onToggleFollowing(following: boolean) {
    this.discussion.author.isFollowing.following = following;

    PNotify.info({
      title: "Hey!",
      titleTrusted: false,
      text: this.discussion.author.isFollowing.following
        ? "You are now following " + this.discussion.author.username
        : "You are no longer following " + this.discussion.author.username,
      textTrusted: false,

      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 3000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
    });
  }
}
